import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textMObj } = typographyStyles;

const greyDark = colors.ui.neutral[600];

export const rootCss = {
  display: "flex",
  backgroundColor: colors.brand.bisque[50],
  borderRadius: "4px",
  padding: "16px",
  width: "100%",
};

export const textCss = {
  ...textMObj,
  margin: 0,
  color: greyDark,
  lineHeight: "24px",

  div: {
    display: "inline-block",
  },
};

export const buttonCss = {
  color: greyDark,
  display: "flex",
  fontWeight: 700,
  gap: 0,
  lineHeight: "inherit",
  textDecoration: "underline",
};

export const iconCss = {
  margin: "2px 8px 0 0",
  width: "100%",
  maxWidth: "24px",
  height: "100%",
  maxHeight: "24px",

  path: {
    stroke: greyDark,
    strokeWidth: 3,
  },
};
